var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94999 10.3998L2.87547 15.4743C2.02678 16.323 1.54999 17.4741 1.54999 18.6743C1.54999 21.1737 3.57612 23.1998 6.07547 23.1998C7.2757 23.1998 8.42678 22.723 9.27547 21.8743L14.35 16.7998M17.55 13.5998L22.6245 8.52529C23.4732 7.6766 23.95 6.52552 23.95 5.32529C23.95 2.82593 21.9239 0.799805 19.4245 0.799805C18.2243 0.799805 17.0732 1.27659 16.2245 2.12529L11.15 7.19981M7.94999 16.7998L17.55 7.19981",
    stroke: "#1C6C2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.bb6d140eb80e90f6fde93c9cad6d7978.svg";
export { ForwardRef as ReactComponent };